import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FontSizes } from '../../../../../../core/config/mainTheme';
import { useConnectionsState } from '../ConnectionsContext/ConnectionsContext';

interface Props {}

const ConnectionDisplayCount: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { connectionsCounts } = useConnectionsState();

  return (
    <Box className={classes.textBox}>
      {t('connections:connectionsDisplayed')}: {connectionsCounts.displayed}
      {connectionsCounts.total > connectionsCounts.displayed
        ? ` ${t('connections:outOf')} ${connectionsCounts.total}`
        : null}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  textBox: {
    marginLeft: '-5px',
    fontSize: FontSizes.font,
  },
}));

export default ConnectionDisplayCount;
